import React from 'react';
import PropTypes from 'prop-types';

import { Stack, Typography, TextField, Box } from '@metarouter-private/mr-mui';

export default function ConfirmDeployContent({ selectedCount, onConfirmInputChange }) {
  const onInputChange = e => {
    onConfirmInputChange(e.target.value);
  };

  const pipelineText = selectedCount === 1 ? 'pipeline' : 'pipelines';

  return (
    <Stack spacing={2}>
      <Typography variant="body1" data-test-id="confirmDeployMessage">
        You are about to deploy {selectedCount} {pipelineText}.
      </Typography>

      <Stack spacing={1}>
        <Typography variant="body2" color="text.secondary" data-test-id="confirmDeployInstructions">
          To confirm and start the deployment process, enter{' '}
          <Typography fontWeight="700" component="span" variant="body2">
            Deploy
          </Typography>{' '}
          below:
        </Typography>

        <Box width="50%">
          <TextField
            fullWidth
            variant="outlined"
            placeholder="Deploy"
            onChange={onInputChange}
            size="small"
            data-test-id="confirmDeployInput"
          />
        </Box>
      </Stack>
    </Stack>
  );
}

ConfirmDeployContent.propTypes = {
  selectedCount: PropTypes.number.isRequired,
  onConfirmInputChange: PropTypes.func.isRequired,
};
